import styled from "styled-components";
import worldcup_img from "../../../../assets/images/worldcup_popup.png";

const CoveragePopUpWrapper = styled.div`
  .p-dialog-title {
    color: #6b47f5;
  }
  .p-button {
    background-color: #6b47f5;
    color: #fff;
    border-color: #6b47f5;
    padding: 10px 30px;

    &:hover {
      background-color: #4f46e5;
      border-color: #4f46e5;
    }
  }

  .closeText {
    padding-top: 7px;
    font-size: 13px !important;
    font-weight: 700;
  }
  .p-dialog-footer {
    text-align: center;
  }
  .listContent {
    list-style: none;
    font-weight: 400;
    font-size: 13px;
    color: #4c565c;
    margin-top: 12px;
    margin-bottom: 0px;
    padding-left: 0px;

    li {
      display: flex;
      align-items: flex-start;
    }
  }
  .listContent-rtl {
    list-style: none;
    font-weight: 400;
    font-size: 13px;
    color: #4c565c;
    margin-top: 12px;
    margin-bottom: 0px;
    padding-right: 0px;

    li {
      display: flex;
      align-items: flex-start;
    }
  }
  .iconStyle {
    padding-right: 12px;
  }
  .iconStyle-rtl {
    padding-left: 12px;
  }
  .secondaryListItem {
    padding-left: 32px;
  }
  .primaryListItem {
    padding-bottom: 9px;
  }
  .container-fluid {
    text-align: initial;
  }
  .linePadding {
    padding-left: 50px;
  }
  .headerIcon1 {
  }
  .headerTitle {
    font-size: 22px;
    font-weight: 700;
    color: #6b47f5;
  }
  .headerTitle-stc {
    font-size: 22px;
    font-weight: 700;
    color: #4f008c;
  }
  .worldcup_bg_img {
    background-image: url(${worldcup_img});
    background-repeat: no-repeat;
    background-size: cover;
  }
  .worldcup_coverage {
    .worldcup_coverage_header {
      display: flex;
      align-items: center;
      justify-content: center;
      p,
      h2 {
        margin: 0;
        color: #ffffff;
      }
      div {
        margin: 0 10px;
      }
    }
    .listContent,
    .listContent-rtl {
      color: #ffffff;

      img {
        margin-top: 2px;
      }
    }
    .terms_condition_txt {
      color: #6b47f5;
      font-size: 0.6rem;
      text-align: right;
    }
    .terms_condition_txt_rtl {
      text-align: left;
    }
    .terms_condition_txt-stc {
      color: #4f008c;
      font-size: 0.6rem;
      text-align: right;
    }
    .worldcup_coverage_more_info {
      width: fit-content;
      border: 1px solid #ffffff;
      border-radius: 5px;
      padding: 2px 15px;
      margin-bottom: 10px;
      cursor: pointer;

      .p-progress-spinner {
        height: 10px;
      }

      span {
        text-transform: capitalize;
        margin: 0 5px;
        color: #ffffff;
        font-weight: 400;
        font-size: 0.8rem;
      }
    }
  }
`;

export default CoveragePopUpWrapper;
